import { Expose, Type } from "class-transformer";
import { IsArray, IsDefined, IsNumber, IsOptional, IsString, IsUUID, MaxLength, ValidateNested } from "class-validator";
import { v4 as uuid } from "uuid";

import { GField, GObjectType } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";

import { VehicleTypeCosts } from "./VehicleTypeCosts";

type Coordinate = [number, number];

@GObjectType("Region")
@CDEntity("regions")
export class Region extends CDBaseEntity {
    @GField()
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @GField()
    @CDColumn()
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public countryId: string;

    @GField()
    @CDColumn()
    @MaxLength(64)
    @IsString()
    @IsDefined()
    @Expose()
    public localName: string = "";

    @GField()
    @CDColumn()
    @MaxLength(64)
    @IsString()
    @IsDefined()
    @Expose()
    public englishName: string = "";

    @GField()
    @CDColumn()
    @MaxLength(64)
    @IsString()
    @IsDefined()
    @Expose()
    public timeZoneName: string = "";

    @GField()
    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    public guidePrice: number = 10;

    @GField()
    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    public guideMinimalPrice: number = 50;

    @GField()
    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    public guideLocationPrice: number = 10;

    @GField()
    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    public roundtripGuideCoefficient: number = 1.5;

    @GField()
    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    public roundtripMinimumCoefficient: number = 1.5;

    @CDColumn()
    @IsArray()
    @IsDefined()
    @Expose()
    @Type(() => VehicleTypeCosts)
    @ValidateNested({ each: true })
    public vehicleTypeCosts: VehicleTypeCosts[] = [];

    @Expose()
    @CDColumn()
    @IsOptional()
    public geoFencePolygon: Coordinate[] = [];
}
